module.exports = __webpack_public_path__ + "0f33cb4b14255e386d6016fdb01ec8d8.pdf";